import React from 'react'
// import { TransitionGroup, CSSTransition } from "react-transition-group";

import project from '../../project'
import Data from './Data'

import { Tracking } from '../../../NodeModules/nnd-track-page'

import { ajaxSetup, getJSON } from 'jquery'
import axios from 'axios';

import "../assets/styles/home.scss"

import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

let environment = 'PROD' // PROD or DEV
const apiUrl = (environment === 'PROD') ? 'https://us-central1-ncau-editorial-dapi-prod.cloudfunctions.net/app/api/v1' : 'https://us-central1-ncau-editorial-dapi-dev.cloudfunctions.net/app/api/v1'
const apiURL_storage = (environment === 'PROD') ? 'https://storage.googleapis.com/dapi-prod-data/AFLTradingRating.json' : 'https://storage.googleapis.com/dapi-dev-data/AFLTradingRating.json'

ajaxSetup({ cache: true })

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      view: 'QLD',
      firstInteraction: false,
      votingDisabled: false,
      voteData: null,
      voteDataStorage: null,
      sliderMin: 0,
      sliderMax: 10,
      data: undefined, //this.loadData()
      slider1: 5,
      slider2: 5,
      slider3: 5,
      slider4: 5,
      slider5: 5,
      slider6: 5,
      slider7: 5,
      slider8: 5,
      slider9: 5,
      slider10: 5,
      slider11: 5,
      slider12: 5,
      slider13: 5,
      slider14: 5,
      slider15: 5,
      slider16: 5,
      slider17: 5,
      slider18: 5
    }

    const thisState = this

    // this.addBodyEvents()

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })
    
  }

  componentDidMount () {
    this.loadData()
  }

  /*addBodyEvents () {
    setTimeout(() => {
      let navFromTop = document.getElementsByClassName('nnd-navigation')
      let navFromTopBg = document.getElementsByClassName('nnd-navigation-bg')
      let navWidth = navFromTop[0].clientWidth
      let navTopOffset = navFromTop[0].offsetTop
      window.addEventListener('scroll', (e) => {
        // this.onScrollEvent(navFromTop, navFromTopBg, navWidth, navTopOffset)
      })
    }, 1000)
  }*/

  /*onScrollEvent (navFromTop, navFromTopBg, navWidth, navTopOffset) {
    // let nndContainer = document.getElementsByClassName('nnd-container')
    let nndContainer = document.getElementById('nnd-container')
    let lastRowContainer = document.getElementsByClassName('nnd-cont-main')[0].firstElementChild
    let totalHeight = nndContainer.offsetTop + nndContainer.clientHeight - lastRowContainer.clientHeight
    let lastContHeight = nndContainer.clientHeight + navFromTop[0].clientHeight - lastRowContainer.clientHeight * 2
    navFromTop[0].style.width = `${navWidth}px`
    navFromTopBg[0].style.height = `${navFromTop[0].clientHeight}px`    
    if (window.scrollY > navTopOffset) {
      // console.log('scrolled over')
      // console.log('window.scrollY, totalHeight', window.scrollY, totalHeight)
      if (window.scrollY > totalHeight) {
        navFromTop[0].setAttribute('name', 'nnd-absolutefromtop')
        navFromTopBg[0].setAttribute('name', 'nnd-normal')
        navFromTop[0].style.top = `${lastContHeight}px`
      } else {
        navFromTop[0].setAttribute('name', 'nnd-fixedtotop')
        navFromTopBg[0].setAttribute('name', 'nnd-fixedtotop')
        navFromTop[0].style.top = `0px`
      }
    } else {
      // console.log('scrolled back')
      navFromTop[0].setAttribute('name', 'nnd-normal')
      navFromTopBg[0].setAttribute('name', 'nnd-normal')
      navFromTop[0].style.top = `0px`
    }
  }*/

  loadData () {
    
    const thisData = Data
    const totalItems = thisData.length
    // const thisState = this

    // console.log('thisData', thisData);
    // console.log('totalItems', totalItems);

    this.setState({
      data: thisData
    })

    this.loadResults()
  }


    
  loadResults () {
    
    // hit storage for PROD
    
    // console.log('Get Votes Storage')
    axios.get(apiURL_storage)
    .then((response) => {
      this.processItems(response.data.items)
      // console.log('response.data', response.data.items);
      /*this.setState({
        voteData: response.data.items
      })*/
    })
    // .catch(err => console.error(err))
    .catch((err) => {
      console.log('err', err)
      console.error(err)
    })
    
    
    // hit api direct fot testing/dev NOT FOR PROD
    /*
    axios.get(`${apiUrl}/vote/fetch`, {
      params: {
        projectName: 'NrlStateOfOrigin2020G1',
        collectionId: 'vote',
        count: 714, // Optional. Set a limit on the number of items returned. Default is 20.
        offset: 0, // Optional. Start offset in the collection. Offsets start at 0. 
      }
    })
    .then((res) => {
      const { count, endOffset, items, startOffset, total } = res.data
      console.log('Fetched votes')
      // console.log('count', count)
      // console.log('endOffset', endOffset)
      // console.log('startOffset', startOffset)
      // console.log('items', items)
      // console.log('total', total)
      // setVoteData(items)

      this.processItems(items)

      this.setState({
        voteData: items
      })
    })
    .catch(err => console.error(err))
    */

    
  }

  processItems (items) {
    // console.log('items', items)
    
    let thisState = this
    // console.log('thisState', thisState)

    let teamsVotes = {}
    let totalTeamsVotes = 0

    items.forEach(function(element) {
      const teamId = element.category.split('_')[0] //.replace('player', '')
      const scoreId = element.category.split('_')[1]
      // console.log('team', teamId, scoreId, element.total)

      teamsVotes[teamId] = teamsVotes[teamId] || {};
      teamsVotes[teamId][scoreId] = element.total
    })

    // console.log('teamsVotes', teamsVotes)

    Object.keys(teamsVotes).forEach(function (key){
        // console.log(teamsVotes[key]);

        let votes = teamsVotes[key]
        let teamTotalVotes = 0
        let teamVoteScore = 0

        Object.keys(votes).forEach(function (key){
          teamTotalVotes = teamTotalVotes + votes[key]
          teamVoteScore = teamVoteScore + ( key * votes[key] )
        })

        totalTeamsVotes = totalTeamsVotes + teamTotalVotes

        const fansVoteAve = (teamTotalVotes === 0) ? 0 : teamVoteScore / teamTotalVotes
        let roundedFansVoteAve = (Math.round(fansVoteAve * 2) / 2).toFixed(1) // round nearest .5
        // console.log('roundedFansVoteAve', fansVoteAve, roundedFansVoteAve)

        roundedFansVoteAve = roundedFansVoteAve.replace('.0', '') // remove trailing zero
        
        const teamID = parseInt( key.replace('team','') )
        // console.log('teamID', teamID, roundedFansVoteAve)
        // console.log('teamID roundedFansVoteAve', teamID, fansVoteAve, roundedFansVoteAve)

        const matchedPlayer = thisState.state.data.filter(team => team.id === teamID);
        // console.log('matchedPlayer', matchedPlayer)
        if (matchedPlayer[0]) {
          matchedPlayer[0].fans = roundedFansVoteAve
        }
        
    })

    // console.log('totalTeamVotes', totalTeamsVotes)
    this.setState({
      voteData: items
    })

  }

  submitvote (e,id,voteBracket) {
    e.persist();
    e.target.classList.add(`nnd-voting`)

    const voteKey = 'team' + id + '_' + voteBracket
    // console.log('voteKey', voteKey)
    
    this.setState({
      votingDisabled: true
    })

    let voteData = this.state.voteData

    // submit the vote

    // SEND VOTE
    const documentId = voteData.filter( (el) => voteKey === el.category )[0].docid
    // console.log('documentId', documentId)
    
    axios.post(`${apiUrl}/vote/send`, {
      projectName: 'AFLTradingRating',
      collectionId: 'vote',
      documentId: documentId
    })
      .then((res) => {
        // console.log('res.data', res.data)
        // e.persist();
        setTimeout(function(){
          this.setState({votingDisabled:false})
          e.target.classList.remove(`nnd-voting`)
          e.target.textContent = `voted`
          e.target.classList.add(`nnd-voted`)
          // below removes click event
          let oldBut = e.target
          let newBut = oldBut.cloneNode(true)
          oldBut.parentNode.replaceChild(newBut, oldBut)

        }.bind(this),1000)


      })
      .catch((err) => {
        // console.error(err)
        setTimeout(function(){
          this.setState({votingDisabled:false})
          e.target.classList.remove(`nnd-voting`)
          e.target.textContent = `voted`
          e.target.classList.add(`nnd-voted`)
          // below removes click event
          let oldBut = e.target
          let newBut = oldBut.cloneNode(true)
          oldBut.parentNode.replaceChild(newBut, oldBut)
        }.bind(this),1000)
        
      })
    
    // end submit vote

  }

  setClassName (e, tabName) {
    if (tabName !== this.state.view) {
      // console.log('tabname', tabName)
      // console.log('e', e)
      
      // let header = document.getElementById(`nnd-header`)
      let container = document.getElementById(`nnd-container`)
      // console.log('container', container)
      document.getElementsByClassName(`nnd-header-active-${this.state.view}`)[0].classList.remove(`nnd-header-active-${this.state.view}`)
      document.getElementsByClassName(`nnd-active-${this.state.view}`)[0].classList.remove(`nnd-active-${this.state.view}`)
      e.target.classList.add(`nnd-active-${tabName}`)
      container.classList.add(`nnd-header-active-${tabName}`)
      const grid = document.querySelector('.nnd-cont-main')
      grid.classList.toggle('nnd-hide')
      setTimeout(() => {
        this.state.view = tabName
        grid.setAttribute('name', `nnd-${tabName}`)
        let ratingReaders = grid.querySelectorAll('.nnd-col-rating')
        /*ratingReaders.forEach((e) => {
          e.classList.toggle('nnd-active-people')
        })*/
        setTimeout(() => {
          grid.classList.toggle('nnd-hide')
          Tracking.trackPageImpression(tabName, project.name)
        }, 200)
      }, 200)
    }
  }

  render() {
    const mylist = (typeof this.state.data !== 'undefined') ? this.state.data.map((item) => {
      // console.log('item.imagename', item)
      if (typeof this.state.data !== 'undefined') {
        return (
          <div key={item.id} className={`nnd-row nnd-team-${item.id}`}>

            <div className="nnd-col-img">
              <img src={require(`../assets/images/${item.imagename}`)} />
            </div>
            <div className="nnd-col-text">
              <h3>{ item.name }</h3>
              <p className="nnd-in"><span>IN: </span>{ item.in }</p>
              <p className="nnd-out"><span>OUT: </span>{ item.out }</p>
              <p className="nnd-picks"><span>PICKS: </span>{ item.picks }</p>
              <p>{ item.desc }</p>
            </div>
           
            <div className="nnd-col-rating">
              <span className='nnd-ratings-heading-expert'>Expert Rating</span>
              <span className='nnd-ratings-headingsub-expert'>{ item.writer }</span>
              <span className="nnd-rating-expert">{ item.rated }</span>
              <span className='nnd-ratings-heading-fans'>Avg Fan Rating</span>
              <span className="nnd-rating-fans">{ item.fans }</span>
            </div>

            <div className="nnd-slider" data-slider-id={ item.id }>
              <span className="nnd-rtp">Rate the club</span>
              <Slider min={this.state.sliderMin} max={this.state.sliderMax} step={0.5} defaultValue={this.state['slider' + item.id]} onChange={value=>this.setState({['slider' + item.id]: value})} />
              <button className="button nnd-submit" disabled={this.state.votingDisabled} onClick={(e) => { this.submitvote(e, item.id, this.state['slider' + item.id]); e.preventDefault() }} >vote</button>
              <span className="nnd-sliderValue" >{this.state['slider' + item.id]}</span>
            </div>
          </div>
        )
      }
    }) : ''

    return (
      <div id="nnd-container" className="nnd-container">
        <div id="nnd-header">
          <img src={require('../assets/images/header.svg')} />
        </div>
        <div name="nnd-afl" className="nnd-cont-main">
          {mylist}
        </div>
      </div>
      
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js